import React from 'react';

import { ProjectDocument } from '../../../../../../../api-client';
import documentIcon from '../../../../../../../assets/images/svg/document.svg';
import { Image } from '../../../../../../../components';
import FileSize from '../../../../../../../components/common/utils/FileSize/FileSize';
import { formatDate } from '../../../../../../../formatters';
import styles from '../DocumentsToProjectsItem.module.scss';

interface Props {
  document: ProjectDocument;
  isHiddenSize?: boolean;
}

export const DifferentDocument = ({ document, isHiddenSize = false }: Props) => {
  if (isHiddenSize)
    return (
      <ul className={styles.documentsToProjectBody__list}>
        <li>
          <a
            href={document.file.url}
            className={styles.documentsToProjectBody__item}
            target="_blank"
            rel="noreferrer"
          >
            <Image className={styles.documentsToProjectBody__icon} src={documentIcon} />
            <div className={styles.documentsToProjectBody__title}>{document.file.name}</div>
            <div className={styles.documentsToProjectBody__size}>
              {formatDate(document.createdAt)}
            </div>
          </a>
        </li>
      </ul>
    );
  else
    return (
      <ul className={styles.documentsToProjectBody__list}>
        <li>
          <a
            href={document.file.url}
            className={styles.documentsToProjectBody__item}
            target="_blank"
            rel="noreferrer"
          >
            <Image className={styles.documentsToProjectBody__icon} src={documentIcon} />
            <div className={styles.documentsToProjectBody__title}>{document.file.name}</div>
            <div className={styles.documentsToProjectBody__size}>
              pdf, <FileSize file={document.file} />
            </div>
            <div className={styles.documentsToProjectBody__date}>
              {formatDate(document.createdAt)}
            </div>
            <div className={styles.documentsToProjectBody__dateText}>дата публикации</div>
          </a>
        </li>
      </ul>
    );
};
